export const getScoreBorderStyles = () => ({
  borderRadius: '8px',
  border: '2px solid #615A69',
  padding: '10px',
});
